import requestAction from '../../utils/requestAction'

export const fetchLogs = (params: string) =>
  requestAction('LOG_LIST', params)(`logs`, 'GET')
